import { render, staticRenderFns } from "./ArealBookings.vue?vue&type=template&id=54f5cbae"
import script from "./ArealBookings.vue?vue&type=script&lang=js"
export * from "./ArealBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports